export default "__VITE_ASSET__220e8fd5__"